import { render, staticRenderFns } from "./Unmatched.vue?vue&type=template&id=5390987a&scoped=true&"
import script from "./Unmatched.vue?vue&type=script&lang=js&"
export * from "./Unmatched.vue?vue&type=script&lang=js&"
import style0 from "./Unmatched.vue?vue&type=style&index=0&id=5390987a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5390987a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
